module.exports = __webpack_public_path__ + "static/img/loading1.7ef136e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading1.gif
// module id = Qx7P
// module chunks = 0